import type { DocsVerificationDocumentTypeEnum, DocsVerificationTypeEnum } from '@models/enums';
import { DocsVerificationSideEnum } from '@models/enums';
import { v4 as uuidv4 } from 'uuid';

export const uploadFileResponse = ({
    documentType,
}: {
    documentType: DocsVerificationTypeEnum;
}) => ({
    document_id: uuidv4(),
    detected_document_type: documentType as unknown as DocsVerificationDocumentTypeEnum,
    detected_two_side_document: false,
    detected_document_side: DocsVerificationSideEnum.MAIN,
    detected_country: 'US',
});
